<template>
  <div
    class="
      sf-layer-rounded sf-bg-danger-subtle-2 sf-c-danger-light-1 sf-below-1
    "
  >
    <div class="sf-pad-h-2 sf-pad-v-1 sf-pointer">
      <div class="sf-level sf-level-between" @click="toggleExpansion">
        <div class="sf-fwdb">
          {{ title }}
        </div>
        <i
          v-if="childrenNumber > 0"
          data-testid="expandable-error-icon"
          class="fa"
          :class="[expanded ? 'fa-chevron-up' : 'fa-chevron-down']"
        />
      </div>
    </div>
    <div v-show="expanded" ref="slotContainerRef">
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref, watch } from 'vue'

defineProps({
  title: {
    type: String,
    required: true,
  },
})

const expanded = ref(false)

const slotContainerRef = ref<HTMLElement | null>(null)

const toggleExpansion = () => {
  expanded.value = !expanded.value
}

const childrenNumber = computed(() => {
  const slotContainer = slotContainerRef.value

  if (!slotContainer || !slotContainer.children || !slotContainer.children[0]) {
    return 0
  }

  // Get the scrolling container for the children
  const innerContainer = slotContainer.children[0]

  if (innerContainer.children) {
    return innerContainer.children.length
  }

  return 0
})

watch(
  childrenNumber,
  (newValue) => {
    if (newValue === 1) {
      expanded.value = true
    }

    if (newValue > 1) {
      expanded.value = false
    }
  },
  { immediate: true }
)
</script>
